import { ElementType } from "react";

export interface FacetedFilterCategoryProps {
  Icon?: ElementType;
  label: string;
}

export default function FacetedFilterCategory(
  props: FacetedFilterCategoryProps,
) {
  const { label, Icon } = props;

  return (
    <div
      className={"px-2 flex flex-row items-center gap-1 text-sm font-medium"}
    >
      {Icon && <Icon className={"h-4 w-4"} />}
      <span>{label}</span>
    </div>
  );
}
